<template>
  <div class="questions">
    <div class="questionsBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="resetSearch" >重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="6">
          <span class="label">题目</span>
          <el-input
            v-model="tableConfig.name"
            placeholder="检查ID或名称"
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <span class="label">分类</span>
          <el-select v-model="tableConfig.type" placeholder="">
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.categoryNo"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span class="label">检查项</span>
          <el-select v-model="tableConfig.checkItemID" placeholder="">
            <el-option
              v-for="(item, index) in checkItemList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="0.5">
          <span class="label">分值</span>
          <el-input
            v-model="tableConfig.score"
            style="width: auto"
          ></el-input>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
          <el-button
            plain
            round
            icon="el-icon-plus"
            size="small"
            style="color: #67C23A"
            @click="openCreate()"
          >
            新 建
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="id"
          label="序号"
          width="100"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="name"
          label="题目名称"
        ></el-table-column>
        <el-table-column
          sortable
          prop="type"
          label="题目分类"
          :formatter="questionTypeFormat"
          width="150"
        ></el-table-column>
        <el-table-column
          sortable
          prop="checkItemName"
          label="检查项"
          width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="score"
          label="分值"
          width="100"
        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)"
            >编辑</el-button
            >
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="delQuestion(scope.row.id)"
            >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";

export default {
  name: "Questions",
  data() {
    return {

      score: '',
      name: '',
      stem: '',
      type: '',
      requires: '',
      checkItemName: '',
      categoryList: [
        {
          name: '陈列',
          categoryNo: 1
        },
        {
          name: '运营',
          categoryNo: 2
        },
        {
          name: '培训',
          categoryNo: 3
        },
      ],
      checkOptionList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: this.$route.query.current*1 || 1, // 当前页码
        name:'',  // 题目
        type: null,  //分类
        checkItemID:'', // 检查项id
        score:''  //分值
      },
      tableLoading: false
    }
  },
  computed: {
    checkItemList: ({ $store: { getters } }) => getters.checkItemList // 检查项
  },
  mounted() {
    this.getData();
    this.$store.dispatch("getStoreCheckItems"); // 检查项
  },
  methods: {
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      let res = await axios.post(oprReqUrl+"/question/search", this.tableConfig);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    resetSearch(){
      this.tableConfig.name = '';
      this.tableConfig.type = null;
      this.tableConfig.checkItemID = '';
      this.tableConfig.score = '';
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openCreate() {
      this.$router.push({ path: '/opr/questionsEdit' });
    },
    openEdit(id) {
      this.$router.push({ path: '/opr/questionsEdit', query: { id, current: this.tableConfig.current } });
    },
    async delQuestion(id){
      await this.$confirm('确定删除该题目吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(oprReqUrl+"/question/delete", {"id":id}).
        then((response) => {
          if (response.data.code === 200) {
            this.getData()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }else {
            this.$message({
              type: 'warning',
              message: response.data.message
            });
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    questionTypeFormat(item){
      switch (item.type){
        case 1:
          return "陈列"
        break;
        case 2:
          return "运营"
        break;
        case 3:
          return "培训"
        break;
        default:
          return "未知"
        break;
      }
    },
  }
};
</script>
<style lang="sass" scoped>
.questions
  min-width: 1050px
  .questionsBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/Check/questions.vue